import React from 'react'
import Detail from '../../Components/Detail/Detail'
import Faq from '../../Components/FAQ/Faq'
import Hero from '../../Components/Hero/Hero'

const Inicio = () => {
  return (
    <div className='layout-page'>
        <Hero />
        <Detail />
        <Faq />

    </div>
  )
}

export default Inicio